export default {
  enums: [
    { id: 'RECEIPT' },
    { id: 'SALES_RECEIPT' },
    { id: 'OTHER' },
  ]
};
